import React from 'react';
import logger from '../../utils/logger';

/**
 * ErrorBoundary mejorado que captura errores de React
 * y muestra una UI de fallback amigable
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null,
            errorInfo: null 
        };
    }

    static getDerivedStateFromError(error) {
        // Actualiza el estado para que la próxima renderización muestre la UI de fallback
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        // Log del error a nuestro servicio de logging
        logger.error('Error capturado por ErrorBoundary:', error, errorInfo);
        
        // Guardar información del error para mostrar en la UI
        this.setState({
            error,
            errorInfo
        });

        // Aquí puedes enviar el error a un servicio de logging externo
        // Ejemplo: Sentry, LogRocket, etc.
        // if (window.Sentry) {
        //     window.Sentry.captureException(error, { extra: errorInfo });
        // }
    }

    handleReset = () => {
        this.setState({ 
            hasError: false, 
            error: null,
            errorInfo: null 
        });
    };

    render() {
        if (this.state.hasError) {
            // UI de fallback personalizada
            const { fallback: Fallback, showDetails = false } = this.props;
            
            if (Fallback) {
                return <Fallback error={this.state.error} resetError={this.handleReset} />;
            }

            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    padding: '20px',
                    textAlign: 'center'
                }}>
                    <h2 style={{ color: '#d32f2f', marginBottom: '16px' }}>
                        ⚠️ Oops! Algo salió mal
                    </h2>
                    <p style={{ marginBottom: '24px', color: '#666' }}>
                        Lo sentimos, ha ocurrido un error inesperado. Por favor, intenta recargar la página.
                    </p>
                    <div style={{ marginBottom: '24px' }}>
                        <button
                            onClick={this.handleReset}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#1976d2',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                marginRight: '10px'
                            }}
                        >
                            Intentar de nuevo
                        </button>
                        <button
                            onClick={() => window.location.reload()}
                            style={{
                                padding: '10px 20px',
                                backgroundColor: '#666',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Recargar página
                        </button>
                    </div>
                    {showDetails && process.env.NODE_ENV === 'development' && this.state.error && (
                        <details style={{
                            marginTop: '20px',
                            padding: '15px',
                            backgroundColor: '#f5f5f5',
                            borderRadius: '4px',
                            textAlign: 'left',
                            maxWidth: '800px',
                            width: '100%'
                        }}>
                            <summary style={{ cursor: 'pointer', fontWeight: 'bold', marginBottom: '10px' }}>
                                Detalles del error (solo en desarrollo)
                            </summary>
                            <pre style={{
                                overflow: 'auto',
                                fontSize: '12px',
                                color: '#d32f2f'
                            }}>
                                {this.state.error.toString()}
                                {this.state.errorInfo && (
                                    <>
                                        {'\n\n'}
                                        {this.state.errorInfo.componentStack}
                                    </>
                                )}
                            </pre>
                        </details>
                    )}
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;

